export type ReleaseNftMetadataCreator = {
  address: string;
  share?: number;
};

export type ReleaseNftMetadataInput = {
  schemaVersion: string;
  name: string;
  description: string;
  image: string | null;
  externalUrl?: string | null;
  includeExternalUrlWhenNullish?: boolean;
  creators: ReleaseNftMetadataCreator[];
  publisherDetails: Record<string, unknown>;
  releaseDetails: Record<string, unknown>;
  media: Array<Record<string, unknown>>;
  files: Array<Record<string, unknown>>;
  androidDetails: Record<string, unknown>;
  androidDetailsBeforeMedia?: boolean;
  i18n?: Record<string, Record<string, string>>;
};

export function buildReleaseNftMetadata({
  schemaVersion,
  name,
  description,
  image,
  externalUrl,
  includeExternalUrlWhenNullish,
  creators,
  publisherDetails,
  releaseDetails,
  media,
  files,
  androidDetails,
  androidDetailsBeforeMedia,
  i18n,
}: ReleaseNftMetadataInput): Record<string, unknown> {
  const canonicalReleaseDetails = {
    ...releaseDetails,
    copyright_url: '',
  };
  const solanaDappStore = androidDetailsBeforeMedia
    ? {
        publisher_details: publisherDetails,
        release_details: canonicalReleaseDetails,
        android_details: androidDetails,
        media,
        files,
      }
    : {
        publisher_details: publisherDetails,
        release_details: canonicalReleaseDetails,
        media,
        files,
        android_details: androidDetails,
      };

  return {
    schema_version: schemaVersion,
    name,
    description,
    image,
    ...(externalUrl || includeExternalUrlWhenNullish
      ? { external_url: externalUrl }
      : {}),
    properties: {
      category: 'dApp',
      creators,
    },
    extensions: {
      solana_dapp_store: solanaDappStore,
      ...(i18n ? { i18n } : {}),
    },
  };
}
